import React from "react";
import { motion } from "framer-motion";

import { Blocks, Bolt, Dog, Flame, Goal, Lock, RailSymbol, Rocket, Subtitles, Trash2 } from "lucide-react";

// Example card data (9 cards)
const cards = [
  { status: "ACTIVE", title: "Koco Widgets - Minimal Design on the App Store", impressions: "83.5k", ctr: "4.26%", cpm: "$3.98", cpc: "$2.95" },
  { status: "ACTIVE", title: "Exclusive Travel Deals from $299 Trip", impressions: "50.2k", ctr: "3.14%", cpm: "$4.22", cpc: "$3.10" },
  { status: "ACTIVE", title: "Ergonomic Chairs Now 30% Off for a Limited Time", impressions: "90.1k", ctr: "5.01%", cpm: "$3.75", cpc: "$2.40" },
  { status: "ACTIVE", title: "Try Our New Caramel Latte with Free Pastry", impressions: "61.5k", ctr: "4.02%", cpm: "$3.50", cpc: "$2.10" },
//   { status: "ACTIVE", title: "Jewelry Collection Launch with Free Gift Wrapping", impressions: "77.5k", ctr: "3.85%", cpm: "$4.00", cpc: "$3.00" },
//   { status: "ACTIVE", title: "Premium Online Workout – 30 Day Challenge", impressions: "102k", ctr: "6.01%", cpm: "$3.20", cpc: "$1.95" },
//   { status: "ACTIVE", title: "Framer Design Top Campaign", impressions: "58k", ctr: "3.52%", cpm: "$4.50", cpc: "$3.40" },
//   { status: "ACTIVE", title: "Organic Snacks – Special Weekend Offer", impressions: "49k", ctr: "2.99%", cpm: "$3.40", cpc: "$2.05" },
//   { status: "ACTIVE", title: "Home Decor Essentials – Trending Collection", impressions: "112k", ctr: "5.20%", cpm: "$3.10", cpc: "$1.75" },
];

export default function CardAnim1({id,mode,colors}) {
  return (<>
   <div className={`lexi${id}-container-ca1`}>
      <div className={`lexi${id}-grid`}>
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className={`lexi${id}-card-ca1`}
            initial={{ opacity: 0, transform: "translateY(40px) scale(0.95)" }}
            animate={{ opacity: 1, transform: "translateY(0) scale(1)" }}
            transition={{ delay: index * 0.15, duration: 0.6, ease: "easeOut" }}
          >
            <div className={`lexi${id}-badge`}>{card.status}</div>
            <h3 className={`lexi${id}-title`}>{card.title}</h3>
            <div className={`lexi${id}-info`}>
              <p><strong>Impressions:</strong> {card.impressions}</p>
              <p><strong>CTR:</strong> {card.ctr}</p>
              <p><strong>CPM:</strong> {card.cpm}</p>
              <p><strong>CPC:</strong> {card.cpc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

    <style>{`:root{
    --card-w${id}: 280px;
  --card-h${id}: 340px;
  --muted${id}: #6b7280;
  --accent${id}: #6b46ff;
}

/* Container centers the layout and shows small screenshot preview on left */
.lexi${id}-container-ca1{
  position:relative;height:400px;
  
  margin:0px auto;
  padding:30px;
  box-sizing:border-box;
  
}




.lexi${id}-card-ca1{
  width:280px;
  height:350px;
  padding:20px;
  box-sizing:border-box;
  border-radius:14px;
  background:var(--glass-bg${id});
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px);
  border:1px solid rgba(99,102,241,0.06);
  box-shadow: 0 8px 30px rgba(16,24,40,0.08);
  position:absolute;
  left:0;
  top:0;
  transform-origin: center;
  transition: transform 320ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms;
  cursor:default;

}

.lexi${id}-card-ca1:hover{
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 18px 50px rgba(16,24,40,0.12);
  z-index: 999 !important;
}

.lexi${id}-badge{
  display:inline-block;
  padding:6px 10px;
  border-radius:8px;
  font-size:12px;
  font-weight:700;
  color:#065f46; /* green */
  background: rgba(16,185,129,0.08);
  width:fit-content;
  margin-bottom:12px;
}

.lexi${id}-title{
  font-size:16px;
  line-height:1.25;
  margin:0 0 12px 0;
color:${mode=="white"?"rgba(31, 29, 29, 0.85)":"rgba(255,255,255,0.85)"} !important;
  font-weight:700;
}

.lexi${id}-info{
  margin-top:auto;
  font-size:13px;
  color:var(--muted${id});
}

.lexi${id}-info p{margin:6px 0}

/* Create staggered stacked layout by targeting nth-child positions */
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(1){background:${colors?.c1};ransform: translate(0px, 20px) rotate(-2deg) scale(0.98); z-index:1 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(2){background:${colors?.c2}; transform: translate(60px, -10px) rotate(2deg) scale(0.99); z-index:2 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(3){ background:${colors?.c1};transform: translate(120px, -30px) rotate(-1deg) scale(1); z-index:3 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(4){ background:${colors?.c2};transform: translate(180px, -10px) rotate(1deg) scale(1.02); z-index:4 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(5){ background:${colors?.c1};transform: translate(240px, 0px) rotate(-1deg) scale(1.03); z-index:5 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(6){ background:${colors?.c2};transform: translate(300px, 10px) rotate(2deg) scale(1.02); z-index:6 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(7){ background:${colors?.c1};transform: translate(360px, 20px) rotate(-2deg) scale(1.01); z-index:7 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(8){ background:${colors?.c2};transform: translate(420px, 30px) rotate(1deg) scale(1); z-index:8 }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(9){background:${colors?.c1}; transform: translate(480px, 40px) rotate(-1deg) scale(0.99); z-index:9 }

/* subtle floating animation for each card (different durations for organic feel) */
@keyframes floatA{ 0%{ transform: translate(0px, 20px) rotate(-20deg) scale(0.58); z-index:1; }50%{ transform: translateY(-6px) }100%{ transform: translate(120px, -30px) rotate(-1deg) scale(0.7); z-index:9; }}
@keyframes floatB{ 0%{  transform: translate(0px, -30px) rotate(-10deg) scale(0.51); z-index:3; }50%{ transform: translateY(-10px) }100%{  transform: translate(220px, -30px) rotate(-1deg) scale(0.7);; z-index:4; }}

.lexi${id}-grid .lexi${id}-card-ca1:nth-child(1){ animation: floatA 6s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(2){ animation: floatA 6.5s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(3){ animation: floatA 7s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(4){ animation: floatA 7.5s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(5){ animation: floatA 8s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(6){ animation: floatA 8.5s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(7){ animation: floatA 9s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(8){ animation: floatA 9.5s ease-in-out infinite; }
.lexi${id}-grid .lexi${id}-card-ca1:nth-child(9){ animation: floatA 10s ease-in-out infinite; }

`}</style>
 </> );
}
